<div class="container py-4">

  <!-- 🔷 TÍTULO -->


  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/ISC-VIRTUAL_BANNER.png" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
      Formar profesionistas líderes con visión estratégica y amplio sentido ético; capaz de diseñar, desarrollar, implementar y administrar tecnología computacional para aportar soluciones innovadoras en beneficio de la sociedad; en un contexto global, multidisciplinario y sostenible.
      </p>
    </div>



   <div class="info-block">
      <h3>PERFIL DE EGRESO</h3>
     <ul>
      <li>	Implementa aplicaciones computacionales para solucionar problemas de diversos contextos, integrando diferentes tecnologías, plataformas o dispositivos.</li>
      <li>	Diseña, desarrolla y aplica modelos computacionales para solucionar problemas, mediante la selección y uso de herramientas matemáticas.</li>
      <li>	Diseña e implementa interfaces para la automatización de sistemas de hardware y desarrollo del software asociado.</li>
      <li>	Coordina y participa en equipos multidisciplinarios para la aplicación de soluciones innovadoras en diferentes contextos.</li>
      <li>	Diseña, implementa y administra bases de datos optimizando los recursos disponibles, conforme a las normas vigentes de manejo y seguridad de la información.</li>
      <li>	Desarrolla y administra software para apoyar la productividad y competitividad de las organizaciones cumpliendo con estándares de calidad.</li>
      <li>	Evalúa tecnologías de hardware para soportar aplicaciones de manera efectiva.</li>
      <li>	Detecta áreas de oportunidad empleando una visión empresarial para crear proyectos aplicando las Tecnologías de la Información y Comunicación.</li>
      <li>	Diseña, configura y administra redes de computadoras para crear soluciones de conectividad en la organización, aplicando las normas y estándares vigentes.</li>
     </ul>
    </div>

   
 
  </section>

 

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://virtual.tecnm.mx/plataforma/login/index.php" target="_blank"
      class="doc-link">
      ■ DOCUMENTACIÓN INGENIERÍA EN SISTEMAS COMPUTACIONALES
    </a>
  </div>

  <hr>


  <div class="btn-section">

    <a href="assets/reticulas/Reticula-Sistemas-TecNMVirtual.jpg" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- CONTACTO  -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFE DE DIVISIÓN</h3>
        <p class="name">Ing. Manuel de Atocha Barrancos Martínez</p>
        <p>E-mail: <a href="mailto:divisionif@itsescarcega.edu.mx">divisionisc@itsescarcega.edu.mx</a></p>
        <P> Telefono: 9821175184 </P>
      </div>
     
     <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Jazmín Solis Rebolledo</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono: 9821047765</p>
      </div>  

    </div>

  </section>

</div>